<!--
    表示/非表示を切り替えるカテゴリのコンポーネント

    使用方法
    １．初期状態が閉じている場合
        <div class="collapse-main-base-scv">
            <AlertSettingItem   alertSettingName="XXX"
                                targetDialog="YYY"
                                :requiredSetting="1">
            </AlertSettingItem>
            <div id="collapseYYY" class="collapse collapse-main-area-scv">
                /* ここに表示/非表示を切り替えたい画面を記載する */

        ・"XXX"にカテゴリ名を指定。
        ・"YYY"で識別名を指定。（必須）

    ２．初期状態で開きたい場合
        <div class="collapse-main-base-scv">
            <AlertSettingItem alertSettingName="XXX"
                              targetDialog="YYY"
                              :requiredSetting="1"
                              :defaultExpanded="true">
            </AlertSettingItem>
            <div id="collapseYYY" class="show collapse collapse-main-area-scv">
                /* ここに表示/非表示を切り替えたい画面を記載する */

    ３．カテゴリ内を伸縮可能な画面にしたい場合
        <div class="collapse-main-base-scv d-flex flex-column flex-grow-1">
            <AlertSettingItem alertSettingName="XXX"
                              targetDialog="YYY"
                              :requiredSetting="1"
                              @opencollapse="opencollapse('collapseYYY')"
                              @closecollapse="closecollapse('collapseYYY')>
            </AlertSettingItem>
            <div id="collapseYYY" class="collapse collapse-main-area-scv">
                /* ここに表示/非表示を切り替えたい画面を記載する */

        private opencollapse(id: string): void {
            const el = document.getElementById(id);
            if (null == el) return;
            el.classList.add("show-collapse-content-flex-grow");
        }

        private closecollapse(id: string): void {
            const el = document.getElementById(id);
            if (null == el) return;
            el.classList.remove("show-collapse-content-flex-grow");
        }

        ※閉じている時に"show-collapse-content-flex-grow"を付けてしまうと、"display: flex"となり画面が非表示にならなかった。
        ※そのため、開閉時に動的に"show-collapse-content-flex-grow"を追加・削除する必要がある。
-->
<template>
    <div v-bind:class="GetTargetItemStyle(isMainCategory, subCategoryMode, enableExpand)"
         style="padding: 0px 0px 0px 8px;"
         v-bind:style="{'min-height': (0 != categoryMinHeight) ? categoryMinHeight + 'px' : '', cursor: enableExpand ? 'pointer' : ''}"
         @click="onClickAlertItemArea">
        <template v-if="isMainCategory === true && targetItem !== -1">
            <div class="d-flex flex-column justify-content-center" style="margin-right: 8px">
                <template v-if="targetItem === 0">
                    <!-- 全て無効 -->
                    <img src="../../assets/img/targetos_win_disable.svg" height="16" width="32" />
                    <img src="../../assets/img/targetos_mac_disable.svg" height="16" width="32" style="margin-top: 2px" />
                </template>
                <template v-else>
                    <!-- Windows -->
                    <template v-if="IsWindowsEnabled(targetItem)">
                        <img src="../../assets/img/targetos_win.svg" height="16" width="32" />
                    </template>
                    <template v-else>
                        <img src="../../assets/img/targetos_win.svg" height="16" width="32" style="opacity: 0.2" />
                    </template>

                    <div style="height:2px"></div>

                    <!-- Mac -->
                    <template v-if="IsMacEnabled(targetItem)">
                        <img src="../../assets/img/targetos_mac.svg" height="16" width="32" />
                    </template>
                    <template v-else>
                        <img src="../../assets/img/targetos_mac.svg" height="16" width="32" style="opacity: 0.2" />
                    </template>
                </template>
            </div>
        </template>

        <div v-bind:class="[isMainCategory ? 'alert-main-category' : 'alert-sub-category']">
            <template v-if="!requiredSetting">
                <input type="checkbox" v-bind:checked="enableSetting" @click="onSettingCheckButton" :id="'enableSetting' + targetDialog">
                <label v-bind:class="GetTargetFontStyle(isMainCategory, subCategoryMode)" class="scv-check-label" v-bind:style="{'max-width': (0 != textMaxWidth) ? textMaxWidth + 'px' : ''}" :for="'enableSetting' + targetDialog" :id="'settingName' + targetDialog">{{alertSettingName}}</label>
            </template>
            <template v-else>
                <span v-bind:class="GetTargetFontStyle(isMainCategory, subCategoryMode)">{{alertSettingName}}</span>
            </template>
            <template v-if="0 < informationHtml.length">
                <InformationManual :arMessage="[informationHtml]"
                                   style="margin-left: 4px;" />
            </template>
            <div style="width:40px"></div>
        </div>

        <div class="d-flex flex-row ms-auto">
            <template v-if="true==existInhibit">
                <div class="d-flex align-items-center">
                    <input type="checkbox" @click="onInhibitCheckButton" :id="'enableInhibit' + targetDialog" v-bind:disabled="enableSetting == 0">
                    <label class="scv-check-label default-text-font" :for="'enableInhibit' + targetDialog" :id="'inhibitText' + targetDialog">禁止</label>
                </div>
            </template>
            <template v-else>
                <!--非表示の際にも、余白は必要なため、ID等未設定の空の要素を用意しておく-->
                <div class="d-flex align-items-center" style="visibility: hidden;">
                    <input type="checkbox">
                    <label class="scv-check-label default-text-font">禁止</label>
                </div>
            </template>
            <template v-if="true==existPopup">
                <div v-bind:class="[true==existInhibit ? 'check-between-margin' : '']"></div>
                <div class="d-flex align-items-center">
                    <input type="checkbox" @click="onPopupCheckButton" :id="'enablePopup' + targetDialog" v-bind:disabled="enableSetting == 0">
                    <label class="scv-check-label default-text-font" :for="'enablePopup' + targetDialog" :id="'popupText' + targetDialog">端末通知</label>
                </div>
                <div style="width:8px"></div>
                <div class="d-flex align-items-end">
                    <button type="button"
                            class="btn-scv-bgcolor"
                            :data-bs-target="'#popupMessageSetting' + targetDialog"
                            v-bind:disabled="enableSetting == 0 || enablePopup == 0"
                            style="min-width: 88px !important; height: 32px; margin-bottom: 6px;"
                            :id="'popupSettingBtn' + targetDialog">
                        通知内容
                    </button>
                </div>
            </template>
            <template v-else>
                <!--非表示の際にも、余白は必要なため、ID等未設定の空の要素を用意しておく-->
                <div class="d-flex align-items-center" style="visibility: hidden;">
                    <div v-bind:class="[true==existInhibit ? 'check-between-margin' : '']"></div>
                    <div class="d-flex align-items-center">
                        <input type="checkbox">
                        <label class="scv-check-label default-text-font">端末通知</label>
                    </div>
                    <div style="width:8px"></div>
                    <div class="d-flex align-items-end">
                        <button type="button"
                                class="btn-scv-bgcolor"
                                style="min-width: 88px !important; height: 32px; margin-bottom: 6px;">
                            通知内容
                        </button>
                    </div>
                </div>
            </template>
            <div style="width:8px"></div>
            <template v-if="true==enableExpand || true==enableExpandHidden">
                <div class="d-flex align-items-center" v-bind:style="{'visibility': (true == enableExpandHidden) ? 'hidden' : ''}">
                    <div :id="'heading' + targetDialog">
                        <div class="expand-button">
                            <i :class="expandIconClass"></i>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>

    <template v-if="true==existPopup">
        <!--端末ダイアログ -->
        <AlertPopupMessageSetting :alertSettingName="alertSettingName" :popupMessage="editPopupMessage" @onApplyPopupMessageButton="onApplyPopupMessageButton" :targetDialog="targetDialog" />
    </template>
</template>

<script lang="ts">
    import { Vue, Options } from "vue-class-component";
    import $ from "jquery";
    import AlertPopupMessageSetting from '@/components/Alert/AlertPopupMessageSetting.vue';
    import { SubCategoryMode } from '@/models/Alert/SubCategoryMode';
    import { AlertTargetItem } from '@/models/Alert/AlertTargetItem';
    import InformationManual from '@/components/InformationManual.vue';
    import { BootstrapUtil } from "lib-vue-v2/util";
    import { Tooltip } from "bootstrap";

    @Options({
        props: {
            altSubCtgry: Number,
            alertSettingName: String,   /* 設定タイトル */
            requiredSetting: Number,    /* 必須設定かどうか（1 : チェックボックスなし, 0 : チェックボックスあり） */
            enableSetting: Number,      /* チェックボックスの有効/無効 */
            existInhibit: Number,       /* 禁止の有無 */
            enableInhibit: Number,      /* 禁止の初期値 */
            existPopup: Number,         /* 端末通知の有無 */
            enablePopup: Number,        /* 端末通知(チェック)の初期値 */
            popupMessage: String,       /* 端末通知(メッセージ)の初期値 */
            isMainCategory: { type: Boolean, default: true },   /* メインカテゴリかどうか */
            defaultExpanded: { type: Boolean, default: false },   /* デフォルトの開閉状態 */
            targetDialog: String,       /* 設定のプレフィックス */
            enableExpand: { type: Boolean, default: true },         /* 開閉ボタンの有無 */
            enableExpandHidden: { type: Boolean, default: false },  /* 開閉ボタンの有無(開閉ボタンは表示しないが開閉ボタン分の領域はそのまま) */
            subCategoryMode: { type: Number, default: 0 },      /* サブカテゴリ種別(enum SubCategoryMode) */
            targetItem: { type: Number, default: -1 },          /* 対象項目(enum AlertSettingItem) ※初期値(-1)の場合はアイコン非表示 */
            informationHtml: { type: String, default: '' },      /* 設定タイトル横につけるインフォメーションhtml */
            categoryMinHeight: { type: Number, default: 0 },     /* カテゴリの最小高さを明示的に指定 */
            textMaxWidth: { type: Number, default: 0 },          /* 設定タイトルの幅を明示的に指定 */
        },
        emits: [
            /**
             * @brief	チェックボックスを押下
             * @param	1 : チェックされた'targetDialog'
             * @param	2 : チェックのオン/オフ(boolean)
             */
            'onSettingCheckButton',
            'onPopupCheckButton',
            'onApplyPopupMessageButton',
            'onInhibitCheckButton',

            /**
             * @brief	開かれた時に呼び出されます
             */
            'opencollapse',

            /**
             * @brief	描画時に呼び出されます
             */
            'showncollapse',

            /**
             * @brief	閉じられた時に呼び出されます
             */
            'closecollapse'
        ],
        components: {
            AlertPopupMessageSetting,
            InformationManual,
        },
    })
    export default class AlertSettingItem extends Vue {

        private targetDialog!: string;
        private popupMessage!: string;
        private existInhibit!: number;
        private enableInhibit!: number;
        private existPopup!: number;
        private enablePopup!: number;
        private enableExpand!: boolean;

        private editPopupMessage = "";
        private expandIconClass = "icon-font-size icon-arrow1right";
        private defaultExpanded!: boolean;
        private informationHtml!: string;

        public created() {
            // 他画面からの遷移時にテキストを反映させるために必要
            this.editPopupMessage = this.popupMessage;
        }

        public mounted(): void {
            this.changeCheckBoxState();

            if (this.enableExpand) {
                // 表示、非表示でアイコンを切り替える
                // 表示
                const el = document.getElementById('collapse' + this.targetDialog);
                if(null != el) {
                    el.addEventListener('show.bs.collapse', (e: Event) => {
                        if (!(e.target instanceof HTMLElement)) {
                            return;
                        }
                        // サブカテゴリがあると子カテゴリの表示イベントまで来る
                        // そのため、ここにきたイベントが自分のものかを判定する
                        if (e.target.id == 'collapse' + this.targetDialog) {
                            this.expandIconClass = "icon-font-open icon-arrow1down";
                            this.$emit("opencollapse");
                        }

                        // ツールチップが表示されていれば非表示にする
                        this.hideTooltip('[data-bs-toggle="tooltip tooltip-font scv-tooltip-manual"]');
                    });

                    el.addEventListener('shown.bs.collapse', (e: Event) => {
                        if (!(e.target instanceof HTMLElement)) {
                            return;
                        }
                        // サブカテゴリがあると子カテゴリの表示イベントまで来る
                        // そのため、ここにきたイベントが自分のものかを判定する
                        if (e.target.id == 'collapse' + this.targetDialog) {
                            this.$emit("showncollapse");
                        } 
                    });

                    el.addEventListener('hide.bs.collapse', (e: Event) => {
                        if (!(e.target instanceof HTMLElement)) {
                            return;
                        }
                        // サブカテゴリがあると子カテゴリの非表示イベントまで来る
                        // そのため、ここにきたイベントが自分のものかを判定する
                        if (e.target.id == 'collapse' + this.targetDialog) {
                            this.expandIconClass = "icon-font-size icon-arrow1right";
                            this.$emit("closecollapse");
                        }

                        // ツールチップが表示されていれば非表示にする
                        this.hideTooltip('[data-bs-toggle="tooltip tooltip-font scv-tooltip-manual"]');
                    });
                }

                // 初期状態が開くならアイコンを変えておく
                if (this.defaultExpanded) {
                    this.expandIconClass = "icon-font-open icon-arrow1down";
                }
            }
        }

        public updated() {
            this.changeCheckBoxState();
        }

        public beforeUpdate() {
            // DBからのデータ取得時にテキストを反映させるために必要
            this.editPopupMessage = this.popupMessage;
        }

        /**
         * @brief   適用するスタイルを取得します。
         * @param   isMainCategory      メインカテゴリか否か
         * @param   subCategoryMode     サブカテゴリ種別
         * @param   enableExpand        開閉ボタンの有無
         * @returns 適用するスタイル
         */
        public GetTargetItemStyle(isMainCategory: boolean, subCategoryMode: number, enableExpand: boolean): string {
            if (isMainCategory) {
                // アラートメインカテゴリ
                return enableExpand ? 'alert-setting-item alert-setting-item-expand' : 'alert-setting-item';
            }
            // 以下はサブカテゴリ
            if (subCategoryMode === SubCategoryMode.OS) {
                // OS
                return enableExpand ? 'alert-sub-setting-os-item alert-sub-setting-os-item-expand' : 'alert-sub-setting-os-item';
            }
            else if (subCategoryMode === SubCategoryMode.SubSubItem) {
                // サブサブカテゴリ
                // 開閉時のホバー色はサブカテゴリと同じ
                return enableExpand ? 'title-belt-subsubcategory alert-sub-setting-item-expand' : 'title-belt-subsubcategory';

            }
            // サブアイテム(デフォルト)
            return enableExpand ? 'alert-sub-setting-item alert-sub-setting-item-expand' : 'alert-sub-setting-item';
        }

        /**
         * @brief   適用するフォントを取得します。
         * @param   isMainCategory      メインカテゴリか否か
         * @param   subCategoryMode     サブカテゴリ種別
         * @returns 適用するフォント
         */
        public GetTargetFontStyle(isMainCategory: boolean, subCategoryMode: number): string {
            if (isMainCategory) {
                // アラートメインカテゴリ
                return 'main-category-font';
            }
            // 以下はサブカテゴリ
            // ※サブサブカテゴリもフォントは同じ
            return 'sub-category-font';
        }

        /**
         * @brief   Windowsが対象か否かを取得します。
         * @param   targetItem  アラート対象項目
         * @returns Windowsが対象か否か
         */
        public IsWindowsEnabled(targetItem: number): boolean {
            return ((targetItem & AlertTargetItem.Windows) !== 0);
        }

        /**
         * @brief   Macが対象か否かを取得します。
         * @param   targetItem  アラート対象項目
         * @returns Macが対象か否か
         */
        public IsMacEnabled(targetItem: number) {
            return ((targetItem & AlertTargetItem.Mac) !== 0);
        }

        /**
         *  設定切り替えボタン押下時イベント
         */
        private onSettingCheckButton() {
            const checkButton = document.getElementById("enableSetting" + this.targetDialog) as HTMLInputElement;
            // 親に通知
            this.$emit("onSettingCheckButton", this.targetDialog, checkButton.checked);
        }

        /**
         *  禁止切り替えボタン押下時イベント
         */
        private onInhibitCheckButton() {
            const checkButton = document.getElementById("enableInhibit" + this.targetDialog) as HTMLInputElement;
            var enableInhibit = 0;
            if (checkButton.indeterminate) {
                enableInhibit = 2;
            }
            else {
                if (checkButton.checked) {
                    enableInhibit = 1;
                }
                else {
                    enableInhibit = 0;
                }
            }
            // 親に通知
            this.$emit("onInhibitCheckButton", this.targetDialog, enableInhibit);
        }

        /**
         *  端末通知切り替えボタン押下時イベント
         */
        private onPopupCheckButton() {
            const checkButton = document.getElementById("enablePopup" + this.targetDialog) as HTMLInputElement;
            var enablePopup = 0;
            if (checkButton.indeterminate) {
                enablePopup = 2;
            }
            else {
                if (checkButton.checked) {
                    enablePopup = 1;
                }
                else {
                    enablePopup = 0;
                }
            }
            // 親に通知
            this.$emit("onPopupCheckButton", this.targetDialog, enablePopup);
        }

        /**
         *  端末通知入力イベント
         */
        private onApplyPopupMessageButton(popupMessage: string) {
            this.editPopupMessage = popupMessage;
            // 親に通知
            this.$emit("onApplyPopupMessageButton", this.targetDialog, popupMessage);
        }

        /**
         *  端末通知と禁止のチェックボックスの状態を変更する
         */
        private changeCheckBoxState() {

            if (1 == this.existPopup) {
                if (2 == this.enablePopup) {
                    $('#enablePopup' + this.targetDialog).prop('indeterminate', true);
                }
                else {
                    $('#enablePopup' + this.targetDialog).prop('indeterminate', false);
                    const checkButton = document.getElementById("enablePopup" + this.targetDialog) as HTMLInputElement;
                    if (1 == this.enablePopup) {
                        checkButton.checked = true;
                    }
                    else {
                        checkButton.checked = false;
                    }
                }
            }

            if (1 == this.existInhibit) {
                if (2 == this.enableInhibit) {
                    $('#enableInhibit' + this.targetDialog).prop('indeterminate', true);
                }
                else {
                    $('#enableInhibit' + this.targetDialog).prop('indeterminate', false);
                    const checkButton = document.getElementById("enableInhibit" + this.targetDialog) as HTMLInputElement;
                    if (1 == this.enableInhibit) {
                        checkButton.checked = true;
                    }
                    else {
                        checkButton.checked = false;
                    }
                }
            }
        }

        private onClickAlertItemArea(event: any) {
            if (this.enableExpand) {
                var targetEnableSettingID = "enableSetting" + this.targetDialog;
                var targetSettingNameID = "settingName" + this.targetDialog;
                var targetEnableInhibitID = "enableInhibit" + this.targetDialog;
                var targetInhibitTextID = "inhibitText" + this.targetDialog;
                var targetEnablePopupID = "enablePopup" + this.targetDialog;
                var targetPopupTextID = "popupText" + this.targetDialog;
                var targetPopupSettingBtnID = "popupSettingBtn" + this.targetDialog;
                if ((event.target.id != targetEnableSettingID) &&
                    (event.target.id != targetSettingNameID) &&
                    (event.target.id != targetEnableInhibitID) &&
                    (event.target.id != targetInhibitTextID) &&
                    (event.target.id != targetEnablePopupID) &&
                    (event.target.id != targetPopupTextID) &&
                    (event.target.id != targetPopupSettingBtnID)) {
                    // アイテム以外をクリックした場合はアラート設定の開閉を行う
                    BootstrapUtil.toggleCollapseById('collapse' + this.targetDialog);
                }
            }
        }

        /**
         * @brief   補足マニュアル非表示
         * @param   target  補足マニュアル
         * @returns なし
         */
        private hideTooltip(target: string) {
            document.querySelectorAll(target).forEach(x => {
                let tooltipInstance = Tooltip.getInstance(x);
                tooltipInstance?.hide();
            });
        }
    }
</script>

<style scoped>
    /* 本コントロール全体 */
    .alert-setting-item {
        border-bottom: 1px solid #BEE6FF;
        min-height: 45px; /* 44px + 1px(区切り線)*/
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
    }

    /* 本コントロールのホバー時の色（expand有効時） */
    .alert-setting-item-expand:hover {
        background-color: #D6EEFF !important
    }

    /* 本コントロール全体（サブカテゴリ - サブアイテム） */
    .alert-sub-setting-item {
        min-height: 32px;
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        background-color: #EBF5FF;
    }

    /* 本コントロール全体（サブカテゴリ - OS種別） */
    .alert-sub-setting-os-item {
        min-height: 32px;
        display: flex;
        flex-flow: row;
        flex-wrap: wrap;
        border-radius: 2px;
        background-color: rgba(100, 205, 255, 0.3); /* #64CDFF */
    }

    /* サブカテゴリ(サブアイテム)のホバー時の色（expand有効時） */
    .alert-sub-setting-item-expand:hover {
        background-color: #D6EEFF !important
    }

    /* サブカテゴリ(OS種別)のホバー時の色（expand有効時） */
    .alert-sub-setting-os-item-expand:hover {
        background-color: #77ACFF !important
    }

    /* メインカテゴリのタイトル */
    .alert-main-category {
        display: flex;
        align-items: start;
        margin-top: 12px;
    }

    /* サブカテゴリのタイトル */
    .alert-sub-category {
        display: flex;
        align-items: center;
    }

    /* メインカテゴリ時のフォント */
    .main-category-font {
        font-size: 14px;
        color: #2582D7;
        font-weight: 700;
    }

    /* サブカテゴリ時のフォント */
    .sub-category-font {
        font-size: 14px;
        color: #242424;
        font-weight: 500;
    }

    /* チェックボックスとチェックボックスの間のマージン */
    .check-between-margin {
        width: 24px;
    }

    /* 開閉ボタン */
    .expand-button {
        height: 32px;
        width: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer; /* 指カーソル */
    }

</style>
